//import rfact from "../../assets/img/rfact.png";

const workxpArray = [
    {
      id: "rfactory",
      workImg: "rfact.png",
      workTitle: "Software Engineer (Internship)",
      workCompany: "@R-Factory (PVT) Ltd (2021 - 2022)",
      workDescrption: "Worked on a project known as 'Celonese and Sinhasana' which is an E-commerce web application where users and buy items (Furniture, Arts & Crafts, etc) including online payment facility and delivery facility and also bid on items. Administrators can add new items, and manage bidding details on users."
    },
    {
        id: "ramstudios",
        workImg: "ramstudios.jpeg",
        workTitle: "Video Game Programmer",
        workCompany: "@RAM Studios (PVT) Ltd (2022 - 2023)",
        workDescrption: "Worked on a project known as 'Celonese and Sinhasana' which is an E-commerce web application where users and buy items (Furniture, Arts & Crafts, etc) including online payment facility and delivery facility and also bid on items. Administrators can add new items, and manage bidding details on users."
      },
      {
        id: "ey",
        workImg: "ey.png",
        workTitle: "RPA Developer",
        workCompany: "@Ernst & Young (EY) Sri Lanka (2024 - present)",
        workDescrption: "Currently working as an Associate RPA Developer in the Intelligent Automation and Data Analytics team under Technology Consulting division."
      }
    
  ];
  
  module.exports = {
    workxpArray,
  };
  